import { render, staticRenderFns } from "./DialogConfirmCustomer.vue?vue&type=template&id=738005c5&scoped=true&"
import script from "./DialogConfirmCustomer.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmCustomer.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmCustomer.vue?vue&type=style&index=0&id=738005c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738005c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCard,VDialog,VRow})
